angular.module('app').config(plansRouting);

function plansRouting($routeProvider) {
  $routeProvider
    .when('/plans', {
      pageTitle: 'PLANS',
      template: '<plans-page></plans-page>',
      current: 'plans',
      accessPermission: 'index_plan_superadmin',
      authReq: true,
    })
    .when('/plans/new', {
      pageTitle: 'ADD_PLAN',
      template: '<plan-page></plan-page>',
      breadcrumb: {
        label: 'PLANS',
        parent: 'plans',
      },
      current: 'plans',
      accessPermission: 'create_plan_superadmin',
      authReq: true,
    })
    .when('/plans/:id', {
      params: {
        mode: null,
      },
      pageTitle: 'EDIT_PLAN',
      template: '<plan-page></plan-page>',
      breadcrumb: {
        label: 'PLANS',
        parent: 'plans',
      },
      current: 'plans',
      accessPermission: 'update_plan_superadmin',
      authReq: true,
    });
}

plansRouting.$inject = ['$routeProvider'];
